<div class="icon-wrap">
  <wchfs-icon
    [color]="remarks?.length > 0 ? 'primary' : ''"
    svgIcon="pso-legacy:Note_ico"
    size="22"
    wchfsSuffix
    [wchfsTooltip]="remarks"
  ></wchfs-icon>
</div>
